import { ThemeUICSSObject } from '@apia/theme';
import topBar from './topBar';
import content from './content';
import tabsManager from './tabsManager';
/* IMPORT HERE */
const main: ThemeUICSSObject = {
  /* PREPEND HERE */
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  width: '100vw',
  overflow: 'hidden',

  '& > #TopBar': topBar,

  '& > #Content': content,

  tabsManager,
};

export default main;
